import {useRouter} from 'next/router';

import DropAuctionLanding from '@components/dropAuction/landing/index';
import SeoMeta from '@components/common/seo';
const AuctionView = () => {
	const router = useRouter();
	return (
		<>
			<SeoMeta
				title={`Better That | Drop Auctions | Bid when you Dare!`}
				url={router.asPath}
				description={`Exhilarating shopping is here! Bid for products while the price drops, and when the price is right, HIT BUY!`}
				keywords={`drop auctions, auctions, online auction, bid`}
				image={`${process.env.SITE_URL}/img/drop-auction-og.png`}
			/>
			<DropAuctionLanding />
		</>
	);
};
AuctionView.Layout = true;
export default AuctionView;
